import { render } from "./ErrorDetail.vue?vue&type=template&id=4bc5a9b8"
import script from "./ErrorDetail.vue?vue&type=script&lang=js"
export * from "./ErrorDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__